import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    behaviorActionTypes, 
    GET_MASTERDATABYNAME, 
    GET_BEHAVIOR_LIST_API, 
    POST_BEHAVIOR_API, 
    DELETE_BEHAVIOR_API,
    GET_BEHAVIOR_DETAIL_API,
    GET_BEHAVIOR_COLLECT_DATA_LIST_API,
    DELETE_BEHAVIOR_COLLECT_DATA_API,
    GET_BEHAVIOUR_REDUCTION_SINGLE_GRAPH_API,
    UPDATE_BEHAVIOR_COLLECT_DATA_API,
    POST_RAWBEHAVIORDATA_API,
    POST_BEHAVIOR_FROMCOLLECTDATA_API,
    POST_COPYPATIENTBEHAVIORREDUCTION_API,
    Get_PatientBehaviors_Reduction_For_DailySummary
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../actions/utilAction';
import { PatientRecordABCDataList } from '../../../../collectData/componnets/BehaviorData/actions/BehaviourDataActions';

export const getMasterData = (masterData) => {    
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {                
                dispatch(actionCreator(behaviorActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
};

export const getBehaviorList = (searchObj, patientId) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.get_behaviorList.REQUEST));
        fetch(`${GET_BEHAVIOR_LIST_API}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(behaviorActionTypes.get_behaviorList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(behaviorActionTypes.get_behaviorList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_behaviorList', error);
            });
    };
};

export const getBehaviorListDetails = (reductionId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.get_behaviorDetail.REQUEST));
        fetch(`${GET_BEHAVIOR_DETAIL_API}?reductionId=${reductionId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(behaviorActionTypes.get_behaviorDetail.SUCCESS, response));
                } else {
                    dispatch(actionCreator(behaviorActionTypes.get_behaviorDetail.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_behaviorDetail', error);
            });
    };
};

export const saveBehavior = (formProps, patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.save_behavior.REQUEST));
        fetch(`${POST_BEHAVIOR_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.save_behavior.SUCCESS, response));
                    dispatch(PatientRecordABCDataList(patientId))
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.save_behavior.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_behavior', error);
            });
    };
};

export const deleteBehavior = (reductionId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.delete_behavior.REQUEST));
        fetch(`${DELETE_BEHAVIOR_API}?reductionId=${reductionId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.delete_behavior.SUCCESS, response));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.delete_behavior.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.delete_behavior.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_behavior', error);
            });
    };
};


export const getBehaviorCollactDataList = (searchObj) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.get_behaviorCollactDataListByBehaviorId.REQUEST));
        fetch(`${GET_BEHAVIOR_COLLECT_DATA_LIST_API}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(behaviorActionTypes.get_behaviorCollactDataListByBehaviorId.SUCCESS, response));
                } else {
                    dispatch(actionCreator(behaviorActionTypes.get_behaviorCollactDataListByBehaviorId.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_behaviorCollactDataListByBehaviorId', error);
            });
    };
};


export const deleteBehaviorCollactData = (selectedRecordDataIds, recordingTypeName,patientId,behaviorId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.delete_behaviorCollactData.REQUEST));
        fetch(`${DELETE_BEHAVIOR_COLLECT_DATA_API}?selectedRecordDataIds=${selectedRecordDataIds}&recordingTypeName=${recordingTypeName}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.delete_behaviorCollactData.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { 
                                searchText: null, 
                                patientId: patientId, 
                                behaviorReductionId: behaviorId,
                                recordingTypeName: recordingTypeName
                             },
                        pageNumber: 1,
                    };
                    dispatch(getBehaviorCollactDataList(searchObj));
                    
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.delete_behaviorCollactData.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.delete_behaviorCollactData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_behaviorCollactData', error);
            });
    };
};

export const getBehaviourReductionSingleGraphData = (patientId, recordingTypeName, behaviorsReductionId, FromDate, ToDate, graphByStaff, graphType) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.get_behaviourReductionSingleGraph.REQUEST));
        fetch(`${GET_BEHAVIOUR_REDUCTION_SINGLE_GRAPH_API}?patientId=${patientId}&recordingTypeName=${recordingTypeName}&behaviorsReductionId=${behaviorsReductionId}&fromDate=${FromDate}&toDate=${ToDate}&graphByStaff=${graphByStaff}&graphType=${graphType}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(behaviorActionTypes.get_behaviourReductionSingleGraph.SUCCESS, response));
                } else {
                    dispatch(actionCreator(behaviorActionTypes.get_behaviourReductionSingleGraph.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_behaviourReductionSingleGraph', error);
            });
    };
};


export const getPatientBehaviorsReductionForDailySummary = (patientId,behaviorsReductionId,Date) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.get_patientBehaviors_reduction_for_dailySummary.REQUEST));
        fetch(`${Get_PatientBehaviors_Reduction_For_DailySummary}?patientId=${patientId}&behaviorReductionId=${behaviorsReductionId}&sessionDate=${Date}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(behaviorActionTypes.get_patientBehaviors_reduction_for_dailySummary.SUCCESS, response));
                } else {
                    dispatch(actionCreator(behaviorActionTypes.get_patientBehaviors_reduction_for_dailySummary.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_behaviourReductionSingleGraph', error);
            });
    };
};


export const UpdateCollectedBehaviorData = (collectedBehaviorDataId, recordDataDetailId, sessionDate, staffId, value, duration, patientId, behaviorId, action, recordingTypeName) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(behaviorActionTypes.update_collectedBehaviorDataStatus.REQUEST));
      fetch(`${UPDATE_BEHAVIOR_COLLECT_DATA_API}?collectedBehaviorDataId=${collectedBehaviorDataId}&recordDataDetailId=${recordDataDetailId}&sessionDate=${sessionDate}&staffId=${staffId}&value=${value}&duration=${duration}&patientId=${patientId}&actionName=${action}&recordingTypeName=${recordingTypeName}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);            
            let searchObj = {
                sort_fields: '',
                sort_order: '',
                contain_filters: { 
                        searchText: null, 
                        patientId: patientId, 
                        behaviorReductionId: behaviorId,
                        recordingTypeName: recordingTypeName
                     },
                pageNumber: 1,
            };
            dispatch(getBehaviorCollactDataList(searchObj))

          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(behaviorActionTypes.update_collectedBehaviorDataStatus.SUCCESS, {}));
          }
        })
        .catch(function(error) {
          console.log('error-----', error);
          dispatch(actionCreator(behaviorActionTypes.update_collectedBehaviorDataStatus.SUCCESS, {}));
        });
    };
  };


  export const SaveRawBehaviorData = (formProps, patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.save_rawbehaviordata.REQUEST));
        fetch(`${POST_RAWBEHAVIORDATA_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.save_rawbehaviordata.SUCCESS, response));                  
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.save_rawbehaviordata.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_rawbehaviordata', error);
            });
    };
};

export const saveBehaviorFromCollectData = (formProps, patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.save_behavior.REQUEST));
        fetch(`${POST_BEHAVIOR_FROMCOLLECTDATA_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.save_behavior.SUCCESS, response));
                    dispatch(PatientRecordABCDataList(patientId))
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.save_behavior.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_behavior', error);
            });
    };
};

export const copyPatientBehaviorReduction = (formProps, patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(behaviorActionTypes.save_copyPatientBehaviorReduction.REQUEST));
        fetch(`${POST_COPYPATIENTBEHAVIORREDUCTION_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.save_copyPatientBehaviorReduction.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(behaviorActionTypes.save_copyPatientBehaviorReduction.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_copyPatientBehaviorReduction', error);
            });
    };
};


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Behavior/actions/behaviorActions.js